import Marquee from "react-fast-marquee";

const ITEMS = [
  "Safe & Reliable",
  "10+ Years Experience",
  "Latest Models",
  "Complimentary Wi-Fi",
  "Discreet & Professional",
  "Airport Transfers",
  "Fixed Pricing",
  "24/7 Support",
];

export const MarqueeStrip = () => (
  <section className="border-y border-white/10 bg-ink py-6 md:py-8" data-testid="marquee">
    <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={120}>
      {ITEMS.concat(ITEMS).map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-heading italic text-2xl md:text-4xl text-white/85 px-8 md:px-12">{t}</span>
          <span className="h-2 w-2 rounded-full bg-gold" />
        </div>
      ))}
    </Marquee>
  </section>
);
